import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => {	
	return {	
		links: {
			textDecoration: 'none',
			color: theme.palette.common.black,
			textTransform: 	'capitalize',
		},
		logo:{
			width: 100,
		},
		breadcrumb:{
			marginLeft:60,
			flexDirection:"row",
			display: "flex",
		}
	}
});

export default useStyles;